<template>
    <footer class="footer">
        <span>Version 1.0 Copyright <strong> NAWE-MANAGER </strong> ® 2023 </span>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style>
.footer {
    grid-area: footer;
    background: linear-gradient(to right, #bdc3c7, #2c3e50);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 15px;
    font-size: 0.7rem;
}
</style>
